import { render } from "./lines-chart.vue?vue&type=template&id=635cfd97&scoped=true"
import script from "./lines-chart.vue?vue&type=script&lang=js"
export * from "./lines-chart.vue?vue&type=script&lang=js"

import "./lines-chart.vue?vue&type=style&index=0&id=635cfd97&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635cfd97"]])

export default __exports__